import FocusStyleClass from './Components/FocusStyle'

const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  // Add focus behaviour
  const focusStyle = new FocusStyleClass()
  focusStyle.init()

  // Add main navigation functions
  if (document.querySelector('.header')) {
    import('./Components/Header')
      .then(({ Header }) => {
        const header = new Header()
        header.init()
      })
  }

  // Add dynamic select
  if (document.querySelector('select, .dynamic-select')) {
    import('./Components/DynamicSelect')
      .then(({ DynamicSelect }) => {
        const dynamicSelect = new DynamicSelect()
        dynamicSelect.init()
      })
  }

  // Add video box functions
  if (document.querySelector('video')) {
    import('./Components/Video')
      .then(({ Video }) => {
        const video = new Video()
        video.init()
      })
  }

  // Add youtube box functions
  if (document.querySelector('.youtube-box')) {
    import('./Components/YoutubeBox')
      .then(({ YoutubeBox }) => {
        const youtubeBox = new YoutubeBox()
        youtubeBox.init()
      })
  }

  // Add gallery functions
  if (document.querySelector('.gallery')) {
    import('./Components/Gallery')
      .then(({ Gallery }) => {
        const gallery = new Gallery()
        gallery.init()
      })
  }

  // Init all parallax effects
  if (document.querySelector('.parallax')) {
    import('./Components/Parallax')
      .then(({ Parallax }) => {
        const parallax = new Parallax()
        parallax.init()
      })
  }

  // Cookie bot
  const openCookieSettings = document.querySelectorAll('.open-cookie-settings')
  if (openCookieSettings) {
    [].forEach.call(openCookieSettings, (openCookieSetting, index) => {
      openCookieSetting.addEventListener('click', (event) => {
        event.preventDefault()
        Cookiebot.renew()
      })
    })
  }
})
